export default __webpack_public_path__ + "static/media/funnygifsbox.com-2020-11-16-10-37-09-3.fb086723.gif";